import { db } from '../firebase';
import { collection, addDoc, getDocs, getDoc, doc, updateDoc, deleteDoc, query, where, orderBy, limit, startAfter } from 'firebase/firestore';
import { generateSitemap } from './sitemapService';

const blogsCollection = collection(db, 'blogs');

// Create a new blog
export const createBlog = async (blogData) => {
  try {
    const docRef = await addDoc(blogsCollection, {
      ...blogData,
      createdAt: new Date(),
      updatedAt: new Date()
    });
    if (blogData.status === 'published') {
      await generateSitemap();
    }
    return docRef.id;
  } catch (error) {
    throw error;
  }
};

// Get all published blogs with pagination support
export const getPublishedBlogs = async (pageLimit = 10, lastDoc = null) => {
  try {
    let q = query(blogsCollection, where('status', '==', 'published'), orderBy('createdAt', 'desc'));
    if (lastDoc) {
      q = query(q, startAfter(lastDoc), limit(pageLimit));
    } else {
      q = query(q, limit(pageLimit));
    }
    const querySnapshot = await getDocs(q);
    const blogs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
    return { blogs, lastDoc: lastVisible };
  } catch (error) {
    throw error;
  }
};

// Get blog by slug
export const getBlogBySlug = async (slug) => {
  try {
    const q = query(blogsCollection, where('slug', '==', slug), where('status', '==', 'published'));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      return { id: doc.id, ...doc.data() };
    }
    return null;
  } catch (error) {
    throw error;
  }
};
// Get blog by id
export const getBlogById = async (id) => {
  try {
    const blogRef = doc(db, 'blogs', id);
    const docSnap = await getDoc(blogRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error('Blog not found');
    }
  } catch (error) {
    throw error;
  }
};

// Get all blogs (for admin)
export const getAllBlogs = async () => {
  try {
    const q = query(blogsCollection, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  } catch (error) {
    throw error;
  }
};

// Update a blog
export const updateBlog = async (id, updateData) => {
  try {
    const blogRef = doc(db, 'blogs', id);
    await updateDoc(blogRef, {
      ...updateData,
      updatedAt: new Date()
    });
    if (updateData.status === 'published') {
      await generateSitemap();
    }
  } catch (error) {
    throw error;
  }
};

// Delete a blog
export const deleteBlog = async (id) => {
  try {
    const blogRef = doc(db, 'blogs', id);
    await deleteDoc(blogRef);
  } catch (error) {
    throw error;
  }
};